import BlockSlider, { Button, FlatButton } from "@components/BlockSlider"
import ProductBlockWithForm, {
  ProductBlockWithFormProps,
} from "@components/ProductBlockWithForm"
import breakpoints from "@constants/breakpoints"
import React from "react"
import styled from "styled-components"

const Container = styled.div`
  ${Button} {
    display: none;
  }

  ${FlatButton} {
    display: none;
  }
`

const containerStyles = `
  padding: 0 0 88px;

  @media ${breakpoints.laptop} {
    padding: 0 0 calc(1 / 12 * 100vw);
  }
`

interface ProductSliderProps {
  products: Array<ProductBlockWithFormProps>
  title: string
}

const ProductSlider: React.FC<ProductSliderProps> = ({ products, title }) => {
  return (
    <Container>
      <BlockSlider
        containerStyles={containerStyles}
        data={products}
        renderBlock={(block) => <ProductBlockWithForm {...block} />}
        title={title}
        titleShort={title}
        toText=""
        toTextShort=""
      />
    </Container>
  )
}

export default ProductSlider
